import React, { useState, useEffect } from "react";

import Header from "../OrderManagement/Header";
import ItemShowPage from "../Item/Show";

import { headers } from "../../utils/utils";

import { DataGrid } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";

import {
  Box,
  Typography,
  CircularProgress,
  Button,
  Link,
  Chip,
  LinearProgress,
} from "@mui/material";

import { Add as AddIcon, Inbox as InboxIcon } from "@mui/icons-material";



const List = () => {
  const [itemList, setItemList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [totalItemCount, setTotalItemCount] = useState(0);
  useEffect(() => {
    fetchItemList();
  }, [paginationModel]);

  if (selectedRow) {
    // Render the ShowPage component when a row is selected
    return <ItemShowPage id={selectedRow.id} />;
  }

  const columns = [
    { field: "code", headerName: "Code", flex: 0.5 },
    {
      field: "image",
      headerName: "",
      renderCell: (params) => (
        <div>
          <img
            src={params.row.image}
            alt={params.row.name}
            style={{
              width: 80,
              height: 80,
              marginRight: 10, // Space between the image and text
              objectFit: "cover",
              borderRadius: "5px", // Optional: rounded corners for the image
            }}
          />
        </div>
      ),
      flex: 0.5,
    },
    { field: "name", headerName: "Name", flex: 2 },
    { field: "description", headerName: "Description", flex: 2 },

    {
      field: "categoryId",
      headerName: "Category",
      flex: 0.5,
      renderCell: (params) => {
        const category = params.value; // Assuming the categoryId is a string or ID

        return (
          <div
            style={{
              display: "flex",
              marginTop: 40,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Chip
              label={category}
              color="warning"
              variant="outlined"
              size="small"
              style={{ fontWeight: "bold", margin: "0 auto" }}
            />
          </div>
        );
      },
    },

    {
      field: "salePrice",
      headerName: "Price",
      flex: 0.5,
      renderCell: (params) => {
        const price = params.value;
        const formattedPrice = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "INR",
        }).format(price);

        return (
          <div style={{ marginTop: 40 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "green" }}
            >
              {formattedPrice}
            </Typography>
          </div>
        );
      },
    },

    {
      field: "demo",
      headerName: "Stock",
      flex: 0.5,
      renderCell: (params) => {
        const stock = params.row.stockQuantity;
        const maxStock = 100; // Set a maximum stock value (you can adjust this as per your data)

        // Calculate the progress based on the stock value
        const progress = Math.min(stock / maxStock, 1); // Ensure the progress doesn't exceed 100%

        return (
          <div style={{ marginTop: 50 }}>
            <LinearProgress
              variant="determinate"
              value={progress * 100} // Set the progress percentage (0-100)
              sx={{
                height: 10, // Progress bar height
                borderRadius: 5, // Rounded corners
                backgroundColor: "#e0e0e0", // Background color for empty part of the progress bar
                "& .MuiLinearProgress-bar": {
                  borderRadius: 5, // Rounded corners for the progress bar
                  backgroundColor:
                    stock > 50 ? "green" : stock > 10 ? "yellow" : "red", // Color based on stock
                },
              }}
            />
          </div>
        );
      },
    },

    {
      field: "stockQuantity",
      headerName: "Qty",
      flex: 0.5,
      renderCell: (params) => {
        const stock = params.value;

        // Define styles or logic for conditional rendering
        const getChipColor = (stock) => {
          if (stock > 50) return "success";
          if (stock > 10) return "warning";
          return "error";
        };

        return (
          <div>
            <Chip
              label={stock > 0 ? `${stock} in stock` : "Out of Stock"}
              color={getChipColor(stock)}
              variant="outlined"
              size="small"
              sx={{
                fontWeight: "bold",
                fontSize: "12px",
                minWidth: "80px",
                justifyContent: "center",
              }}
            />
          </div>
        );
      },
    },
  ];
  const fetchItemList = async (
    page = paginationModel.page,
    pageSize = paginationModel.pageSize,
  ) => {
    if (itemList.length !== totalItemCount || itemList.length === 0) {
      if (pageSize !== totalItemCount) setLoading(true); // Start loading
      try {
        const response = await fetch(
          process.env.REACT_APP_ITEM +
            `/item/index?pageNumber=${page}&pageSize=${pageSize}`,
          {
            method: "POST",
            body: JSON.stringify({}),
            headers: headers(),
          },
        );

        if (response.ok) {
          const result = await response.json();
          setTotalItemCount(result.totalElements);

          const updatedItems = await Promise.all(
            result.content.map(async (item) => {
              const imageUrl = await fetchItemImage(item.id);
              return {
                ...item,
                stockQuantity: 100,
                image: imageUrl,
              };
            }),
          );
          setItemList(updatedItems);
        } else {
          throw new Error("Failed to fetch items");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false); // End loading
      }
    }
  };
  const handleFilterModelChange = () => {
    fetchItemList(0, totalItemCount);
  };

  const fetchItemImage = async (itemId) => {
    try {
      const imageResponse = await fetch(
        process.env.REACT_APP_ITEM,
        `/item/image/${itemId}`,
        {
          method: "GET",
          headers: headers(),
        },
      );

      if (imageResponse.ok) {
        const imageBlob = await imageResponse.json();
        if (imageBlob && Array.isArray(imageBlob)) {
          return `data:image/jpeg;base64,${imageBlob[0]}`;
        }
      }
    } catch (err) {
      return "default-image-url";
    }
  };

  return (
    <div style={{ background: "white" }}>
      <Header />
      <Box
        p={3}
        sx={{
          margin: "20px",
          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
          background: "white",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          padding="16px"
        >
          <Typography
            variant="h6"
            style={{ display: "flex", alignItems: "center", color: "blue" }}
          >
            <Link
              href="/item"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <InboxIcon style={{ marginRight: "8px" }} />
              Item
            </Link>
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            component={RouterLink} // React Router Link
            to="/new-item" // New Item path
          >
            New Item
          </Button>
        </Box>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ display: "flex", justifyContent: "center", color: "red" }}>
            <Typography variant="body2">{error}</Typography>
          </Box>
        ) : (
          <DataGrid
            rows={itemList}
            columns={columns}
            paginationModel={paginationModel}
            pageSizeOptions={[5, 10]}
            rowCount={totalItemCount}
            onFilterModelChange={handleFilterModelChange}
            onRowClick={(params) => setSelectedRow(params.row)}
            paginationMode="server"
            onPaginationModelChange={(newModel) => {
              setPaginationModel(newModel);
              fetchItemList(newModel.page, newModel.pageSize);
            }}
            pagination
            rowHeight={90}
            components={{
              Footer: () => (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "8px",
                  }}
                >
                  <Typography variant="body2">
                    Total Items: {totalItemCount}
                  </Typography>
                  <Typography variant="body2">
                    Page: {paginationModel.page + 1} of{" "}
                    {Math.ceil(totalItemCount / paginationModel.pageSize)}
                  </Typography>
                </Box>
              ),
            }}
            sx={{
              border: 0,
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f5f5f5",
                cursor: "pointer",
              },
            }}
          />
        )}
      </Box>
    </div>
  );
};

export default List;
